import React from 'react';
import { getDecryptedData, getDecryptedUserType } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import { Box, Typography, Paper, Grid } from '@mui/material';
import Face3Icon from '@mui/icons-material/Face3';
import CakeIcon from '@mui/icons-material/Cake';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import HomeIcon from '@mui/icons-material/Home';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SecurityIcon from '@mui/icons-material/Security';
import PersonIcon from '@mui/icons-material/Person';

const WelComeHeader = ({ patientData }) => {
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();

  const userDetails = LoginUserType === 'Patient' ? LoginUserDetails : patientData;

  const {
    fname,
    lname,
    DOB,
    street,
    city,
    state,
    email,
    phone_contact,
    sex,
    is_medical_history_intake,
    is_financial_disclosure,
    is_hippa_form,
  } = userDetails || {}; // Ensure it doesn’t break if null

  const getTimeGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        background: 'linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)',
        color: 'white',
        borderRadius: '8px',
      }}
    >
      <Grid container spacing={3} alignItems="center">
        {/* 1. Avatar */}
        <Grid item xs={12} sm={1} display="flex" justifyContent="center">
          <Box
            sx={{
              width: 80,
              height: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'white',
              borderRadius: '50%',
            }}
          >
            {sex === 'Male' ? (
              <PersonIcon sx={{ fontSize: 60, color: '#025E73' }} />
            ) : (
              <Face3Icon sx={{ fontSize: 60, color: '#D81B60' }} />
            )}
          </Box>
        </Grid>

        {/* 2. Greeting with Name */}
        <Grid item xs={12} sm={2} sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          {LoginUserType === 'Patient' &&
          <>
            {getTimeGreeting()},<br />
          </>
          }
             {fname} {lname}!
          </Typography>
        </Grid>

        {/* 3. Basic Details */}
        <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
          <Typography variant="body2"><CakeIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>DOB:</strong> {DOB || 'N/A'}</Typography>
          <Typography variant="body2"><EmailIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>Email:</strong> {email || 'N/A'}</Typography>
          <Typography variant="body2"><PhoneIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>Phone:</strong> {phone_contact || 'N/A'}</Typography>
        </Grid>

        {/* 4. Address */}
        <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
          <Typography variant="body2"><HomeIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>Address:</strong></Typography>
          <Typography variant="body2" sx={{ ml: 4 }}>{street || 'N/A'}, <br/>{city || 'N/A'}, {state || 'N/A'}</Typography>
        </Grid>

        {/* 5. Form Status */}
        <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
          <Typography variant="body2"><AssignmentIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>Medical History:</strong> {is_medical_history_intake ? '✔ Submitted' : '❌ Pending'}</Typography>
          <Typography variant="body2"><MonetizationOnIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>Financial Disclosure:</strong> {is_financial_disclosure ? '✔ Submitted' : '❌ Pending'}</Typography>
          <Typography variant="body2"><SecurityIcon sx={{ verticalAlign: 'middle', mr: 1 }} /><strong>HIPAA Form:</strong> {is_hippa_form ? '✔ Submitted' : '❌ Pending'}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default WelComeHeader;
